/**
 * Slim index of the long-form guides published under /guides/<slug>.
 *
 * Kept free of article copy on purpose: routes.ts (and through it proxy.ts)
 * and the sitemap import this file, so the bodies stay out of the proxy
 * bundle. Each slug here must have a content entry in
 * app/(marketing)/guides/_lib/articles (a unit test enforces the pairing).
 *
 * `updated` is the deliberate content date surfaced as dateModified and
 * sitemap lastmod. Bump it only when the article meaningfully changes.
 */
export const GUIDES_HUB_PATH = '/guides';

export const GUIDE_ARTICLE_INDEX = [
  { slug: 'open-a-padel-club-in-saudi-arabia', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'fill-off-peak-padel-courts', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'playtomic-alternatives', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'open-a-pilates-studio-in-saudi-arabia', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'class-packs-vs-memberships', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'reduce-no-shows-and-late-cancellations', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'zatca-e-invoicing-for-sports-clubs-and-gyms', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'saudization-in-sports-centres', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'whatsapp-booking-for-sports-and-fitness', published: '2026-10-15', updated: '2026-10-15' },
  { slug: 'payment-gateways-for-sports-venues-saudi-arabia', published: '2026-10-15', updated: '2026-10-15' },
] as const;

export type GuideArticleSlug = (typeof GUIDE_ARTICLE_INDEX)[number]['slug'];

/** The standalone guide that predates the article template. */
export const LEGACY_GUIDE_PATHS = ['/guides/marketplace-vs-own-booking-app'] as const;

export function guideArticlePath(slug: GuideArticleSlug): `/guides/${GuideArticleSlug}` {
  return `/guides/${slug}`;
}

export const GUIDE_ARTICLE_PATHS = GUIDE_ARTICLE_INDEX.map(({ slug }) => guideArticlePath(slug));

export function findGuideArticleEntry(slug: string) {
  return GUIDE_ARTICLE_INDEX.find((entry) => entry.slug === slug);
}

const LATEST_GUIDE_UPDATE = GUIDE_ARTICLE_INDEX.map(({ updated }) => updated).sort().at(-1);

/**
 * Per-path content dates for the sitemap; paths absent here use the site
 * date. The hub changes whenever a guide is added or updated.
 */
export const GUIDE_LASTMOD_BY_PATH: ReadonlyMap<string, string> = new Map([
  ...GUIDE_ARTICLE_INDEX.map(({ slug, updated }) => [guideArticlePath(slug), updated] as const),
  ...(LATEST_GUIDE_UPDATE ? [[GUIDES_HUB_PATH, LATEST_GUIDE_UPDATE] as const] : []),
]);
